import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';
import { service } from '@ember/service';
import type BetaToggleService from 'scaleflow/services/beta-toggle';
import type RouterService from '@ember/routing/router-service';

/**
 * Archiving is an operator concern, so the tab is platform-admin only. The
 * toggle is hidden for everyone else, and this guard closes the URL as well —
 * same shape as the guard on `scans.scan.processing`.
 *
 * See the note in the sibling `active` route for why the model is the whole
 * collection rather than a pre-filtered one.
 */
class ScansListArchivedRoute extends Route {
  @service declare betaToggle: BetaToggleService;
  @service declare router: RouterService;

  beforeModel() {
    if (!this.betaToggle.isPlatformAdmin) {
      this.router.transitionTo('scans.list.active');
    }
  }

  model() {
    return this.modelFor('scans.list');
  }
}

export default instrumentRoutePerformance(ScansListArchivedRoute);
